// User's uploaded hero brand banner — displayed as a full-width feature plate.
// Kept as-is since it already contains the brand-crafted composition (title,
// portrait, industrial backdrop, KPIs, focus areas, trusted groups).

export default function BrandPlate() {
  return (
    <section
      aria-label="Brand plate — Creating Enterprise Value"
      className="relative border-b border-surface-2 bg-ink overflow-hidden"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-16 pt-20 md:pt-24 pb-4">
        <div className="flex items-center gap-4 text-[11px] uppercase tracking-[0.28em] text-brass mb-8">
          <span className="h-px w-12 bg-brass/50" />
          <span>The Brand Plate</span>
          <span className="text-mutedfg">— Creating Enterprise Value</span>
        </div>
      </div>

      <div className="relative w-full">
        <img
          src="/asad_hero.webp"
          alt="Asad Hatimi — Creating Enterprise Value. Independent Director & Enterprise Program Director."
          width="1536"
          height="1024"
          className="w-full h-auto block"
          loading="lazy"
          decoding="async"
        />
      </div>

      <div className="mx-auto max-w-[1440px] px-6 md:px-16 pb-16 pt-6">
        <div className="hairline mb-6" />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-[11px] uppercase tracking-[0.22em] text-mutedfg">
          <span>Independent Director · Enterprise Program Director</span>
          <span className="md:text-center">Steel · Cement · Power · EPC · Manufacturing</span>
          <span className="md:text-right text-brass">asadhatimi.com</span>
        </div>
      </div>
    </section>
  );
}
